import { createContext } from 'react';
import { IComboGroups } from 'types';

export type TComboGroupsSortBy = '' | 'NameA-Z' | 'NameZ-A';
export type TComboGroupCountOfItems = '12' | '24' | '48';
export type TTypeOfModalWindow = null | 'toConfirmDeleteItem' | 'success' | 'error';
export interface IFilterValues {
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedDish: Nullable<string>;
	sortBy: TComboGroupsSortBy;
	countOfItems: TComboGroupCountOfItems;
	currentPage: number;
}

export interface IComboGroupState {
	comboGroups: IComboGroups;
	searchString: string;
	IDSelectedCustomer: Nullable<string>;
	IDSelectedRestaurant: Nullable<string>;
	IDSelectedDish: Nullable<string>;
	sortBy: TComboGroupsSortBy;
	countOfItems: TComboGroupCountOfItems;
	currentPage: number;
	IDForDeletion: string;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const comboGroupInitialState: IComboGroupState = {
	comboGroups: { comboGroupsCount: 0, comboGroups: [] },
	searchString: '',
	IDSelectedCustomer: null,
	IDSelectedRestaurant: null,
	IDSelectedDish: null,
	sortBy: '',
	countOfItems: '12',
	currentPage: 1,
	IDForDeletion: '',
	typeOfModalWindow: null,
};

export interface IComboGroupContext extends IComboGroupState {
	deleteSelectedItem(): void;
	changeSearchString(value: string): void;
	setIDCustomer(value: Nullable<string>): void;
	setIDRestaurant(value: Nullable<string>): void;
	setIDDish(value: Nullable<string>): void;
	resetSelectedControls(): void;
	setSortBy(sortBy: TComboGroupsSortBy): void;
	setCountOfItems(count: TComboGroupCountOfItems): void;
	changeCurrentPage(page: number): void;
	setIDForDeletion(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setFiltersFromQueryString(value: IFilterValues): void;
}

export const ComboGroupContext = createContext<IComboGroupContext>({
	deleteSelectedItem: () => undefined,
	changeSearchString: () => undefined,
	setIDCustomer: () => undefined,
	setIDRestaurant: () => undefined,
	setIDDish: () => undefined,
	resetSelectedControls: () => undefined,
	setSortBy: () => undefined,
	setCountOfItems: () => undefined,
	changeCurrentPage: () => undefined,
	setIDForDeletion: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	setFiltersFromQueryString: () => undefined,
	...comboGroupInitialState,
});
